import React from 'react'
import { Button } from 'react-bootstrap'
import './UslugaFilter.css'

const UslugaFilter = (props) => {
    return (
        <>
            <div className='group-card' onClick={(e) => props.filterList(e, props.sifraGrupe)}>
                <Button id={"grupa-" + props.sifraGrupe} className={props.listToShow === props.sifraGrupe ? "odabranaGrupa justify-content-md-center" : "grupa justify-content-md-center"}>
                    <h6 style={{ padding: "0" }}>{props.nazivGrupe}</h6>
                </Button>
            </div>
        </>
    )
}

export default UslugaFilter
